import React, { useRef } from 'react';
import { useState } from 'react';
import '../UserRole.css';
import Switch from 'react-switch';
import { Card, CardBody, Container } from 'reactstrap';
import Select from 'react-select';
import axios from '../../axios';
import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useHistory } from 'react-router-dom';
import { FormControl, FormLabel, Grid } from '@material-ui/core';
import {
  Stack,
  Typography,
  Button,
  Dialog,
  LinearProgress,
} from '@mui/material';
import { set } from 'react-ga';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Supplieraccess() {
  let history = useHistory();
  let tokent = sessionStorage.getItem('authtoken');

  //final user in scenario 3
  const finaluser_poapprove_scenarios3 =
    sessionStorage.getItem('WorkScenario') === 'po_with_approval_scenario3' &&
    sessionStorage.getItem('UserRole') === 'final_level';

  //final user in scenario 4
  const finaluser_poapprove_with_branch_scenarios4 =
    sessionStorage.getItem('WorkScenario') ===
      'po_with_approval_and_branches_scenario4' &&
    sessionStorage.getItem('UserRole') === 'final_level';

  const BranchAccess =
    sessionStorage.getItem('WorkScenario') ===
      'po_with_approval_and_branches_scenario4' &&
    sessionStorage.getItem('enable_branch') === 'Y' &&
    sessionStorage.getItem('UserRole') === 'final_level';

  //level 1 user in scenario 3
  const Level_one_user_as_po_create_scenario3 =
    sessionStorage.getItem('WorkScenario') === 'po_with_approval_scenario3' &&
    sessionStorage.getItem('UserRole') === 'level_one';

  //level 1 user in scenario 4
  const Level_one_user_as_po_approve_scenario4 =
    sessionStorage.getItem('WorkScenario') ===
      'po_with_approval_and_branches_scenario4' &&
    sessionStorage.getItem('UserRole') === 'level_one';

  const inventroyAccess = sessionStorage.getItem('enable_inventory') === 'Y';
  const [openLoader, setOpenLoader] = useState(false);
  const [switch1, setswitch1] = useState(true);
  const [switch2, setswitch2] = useState(false);
  const [switch3, setswitch3] = useState(true);
  const [switch4, setswitch4] = useState(
    Level_one_user_as_po_approve_scenario4 ? true : false,
  );
  const [switch5, setswitch5] = useState(false);
  const [switch6, setswitch6] = useState(false);
  const [switch7, setswitch7] = useState(false);
  const [switch8, setswitch8] = useState(false);
  const [switch9, setswitch9] = useState(false);
  const [switch10, setswitch10] = useState(false);
  const [switch11, setswitch11] = useState(false);
  const [switch12, setswitch12] = useState(false);
  const [switch13, setswitch13] = useState(false);
  const [switch14, setswitch14] = useState(false);
  const [switch15, setswitch15] = useState(false);
  const [switch16, setswitch16] = useState(false);
  const [switch17, setswitch17] = useState(false);
  const [switch18, setswitch18] = useState(false);
  const [switch19, setswitch19] = useState(false);
  const [switch20, setswitch20] = useState(false);
  const [switch31, setswitch31] = useState(false);
  const [switch32, setswitch32] = useState(false);
  const [switch33, setswitch33] = useState(false);

  const [switch34, setswitch34] = useState(false);
  const [switch35, setswitch35] = useState(false);
  const [switch36, setswitch36] = useState(false);

  //   Transaction
  const [switch22, setswitch22] = useState(false);
  const [switch23, setswitch23] = useState(false);
  const [switch24, setswitch24] = useState(false);

  // All Transaction
  const [switch25, setswitch25] = useState(false);

  // Indent
  const [switch21, setswitch21] = useState(false);
  const [userhelps, setuserhelps] = useState([]);
  const [userid, setuserid] = useState('');
  const [Userrolesuccess, setUserrolesuccess] = useState(false);
  const [usererr, setusererr] = useState(false);

  const [selectedUser, setSelectedUser] = useState({
    label: 'Please Select User',
    value: 0,
  });

  useEffect(() => {
    userhelp();
  }, []);

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          fontSize: 10,
          color: '#fff',
          fontWeight: 500,
        }}
      >
        {' '}
        No
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          fontSize: 10,
          color: '#fff',
          fontWeight: 500,
        }}
      >
        {' '}
        Yes
      </div>
    );
  };

  const UserRoles = [
    {
      UserId: userid,
      UserModuleId: 1,
      Enable: switch1 ? 'Y' : 'N',
      Visible: switch1 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),

      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 2,
      Enable: switch2 ? 'Y' : 'N',
      Visible: switch2 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 3,
      Enable: switch3 ? 'Y' : 'N',
      Visible: switch3 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 4,
      Enable: switch4 ? 'Y' : 'N',
      Visible: switch4 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 5,
      Enable: switch5 ? 'Y' : 'N',
      Visible: switch5 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 6,
      Enable: switch6 ? 'Y' : 'N',
      Visible: switch6 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 7,
      Enable: switch7 ? 'Y' : 'N',
      Visible: switch7 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 8,
      Enable: switch8 ? 'Y' : 'N',
      Visible: switch8 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 9,
      Enable: switch9 ? 'Y' : 'N',
      Visible: switch9 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 10,
      Enable: switch10 ? 'Y' : 'N',
      Visible: switch10 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 11,
      Enable: switch11 ? 'Y' : 'N',
      Visible: switch11 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 12,
      Enable: switch12 ? 'Y' : 'N',
      Visible: switch12 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 13,
      Enable: switch13 ? 'Y' : 'N',
      Visible: switch13 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 14,
      Enable: switch14 ? 'Y' : 'N',
      Visible: switch14 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 15,
      Enable: switch15 ? 'Y' : 'N',
      Visible: switch15 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 16,
      Enable: switch16 ? 'Y' : 'N',
      Visible: switch16 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 17,
      Enable: switch17 ? 'Y' : 'N',
      Visible: switch17 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 18,
      Enable: switch18 ? 'Y' : 'N',
      Visible: switch18 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 19,
      Enable: switch19 ? 'Y' : 'N',
      Visible: switch19 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 20,
      Enable: switch20 ? 'Y' : 'N',
      Visible: switch20 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
    {
      UserId: userid,
      UserModuleId: 27,
      Enable: switch21 ? 'Y' : 'N',
      Visible: switch21 ? 'Y' : 'N',
      ModifyId: sessionStorage.getItem('Userid'),
      ModifyDt: new Date(),
    },
  ];

  const Getuserrole = async id => {
    setOpenLoader(true);
    setuserid(id.value);
    setSelectedUser({ label: id.label, value: id.value });
    const role = await axios.instance
      .get(`/GetOneSupplierDetails/${id.value}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        if (res.data.length != 0) {
          for (const data of res.data) {
            setswitch1(data.dashboard === 'Y' ? true : false);
            setswitch16(data.customer_Access_Control === 'Y' ? true : false);
            setswitch21(data.Ads_Banner === 'Y' ? true : false);
            setswitch10(data.company === 'Y' ? true : false);
            setswitch11(data.customer === 'Y' ? true : false);
            setswitch12(data.customer_Branch === 'Y' ? true : false);
            setswitch13(data.product_Category === 'Y' ? true : false);
            setswitch15(data.tax === 'Y' ? true : false);
            setswitch14(data.uom === 'Y' ? true : false);
            setswitch18(data.product === 'Y' ? true : false);
            setswitch22(data.quotation === 'Y' ? true : false);
            setswitch23(data.po_Acceptance === 'Y' ? true : false);
            setswitch24(data.so_Status_Update === 'Y' ? true : false);
            setswitch31(data.Department === 'Y' ? true : false);
            setswitch32(data.Designation === 'Y' ? true : false);
            setswitch33(data.User_Register === 'Y' ? true : false);
            setswitch35(data.Company_log==='Y' ? true : false);
            setswitch34(data.Branch_log ==='Y'? true : false);
            setswitch36(data.Company_Branch ==='Y'? true : false);
          }
        } else {
          setswitch1(false);
          setswitch16(false);
          setswitch21(false);
          setswitch10(false);
          setswitch11(false);
          setswitch12(false);
          setswitch13(false);
          setswitch15(false);
          setswitch14(false);
          setswitch18(false);
          setswitch22(false);
          setswitch23(false);
          setswitch24(false);
          setswitch31(false);
          setswitch32(false);
          setswitch33(false);
          setswitch35(false);
          setswitch34(false);
          setswitch36(false);
        }
        setOpenLoader(false);
      });
  };

  const userhelp = async () => {
    await axios.instance
      .get(
        `GetOneSupplierAdminUser
            `,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )

      .then(res => {
        const data = res.data;
        const options = data.map(row => ({
          label: row.User_Name,
          value: row.User_Id,
        }));
        setuserhelps(options);
      });
  };

  const Deleterole = async () => {
    setOpenLoader(true);
    const Deleteroles = await axios.instance.delete(
      `/DeleteSupplierAccessControl/${userid}`,
      {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      },
    );
  };
  const createrole = async () => {
    try {
      setOpenLoader(true);

      if (userid.length !== 0) {
        await Deleterole();
        // for (const data of UserRoles) {
        try {
          await axios.instance.post(
            `/InsertSupplierAccessControl`,
            {
              user_id: userid,
              dashboard: switch1 ? 'Y' : 'N',
              customer_Access_Control: switch16 ? 'Y' : 'N',
              Ads_Banner: switch21 ? 'Y' : 'N',
              company: switch10 ? 'Y' : 'N',
              customer: switch11 ? 'Y' : 'N',
              customer_Branch: switch12 ? 'Y' : 'N',
              product_Category: switch13 ? 'Y' : 'N',
              tax: switch15 ? 'Y' : 'N',
              uom: switch14 ? 'Y' : 'N',
              product: switch18 ? 'Y' : 'N',
              quotation: switch22 ? 'Y' : 'N',
              po_Acceptance: switch23 ? 'Y' : 'N',
              so_Status_Update: switch24 ? 'Y' : 'N',
              Department: switch31 ? 'Y' : 'N',
              Designation: switch32 ? 'Y' : 'N',
              User_Register: switch33 ? 'Y' : 'N',
              Branch_log:switch34 ? 'Y' : 'N',
              Company_log:switch35 ? 'Y' : 'N',
              Company_Branch:switch36? 'Y' : 'N',
              createdby: sessionStorage.getItem('Userid'),
              modifiedby: 0,
            },
            {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            },
          );
        } catch (error) {
          console.error(error);
        }
      }

      setUserrolesuccess(true);

      // Reset switches
      setswitch1(false);
      setswitch2(false);
      setswitch3(false);
      setswitch4(false);
      setswitch5(false);
      setswitch6(false);
      setswitch7(false);
      setswitch8(false);
      setswitch9(false);
      setswitch10(false);
      setswitch11(false);
      setswitch12(false);
      setswitch13(false);
      setswitch14(false);
      setswitch15(false);
      setswitch16(false);
      setswitch17(false);
      setswitch18(false);
      setswitch19(false);
      setswitch20(false);
      setswitch21(false);
      setswitch22(false);
      setswitch23(false);
      setswitch24(false);
      setswitch25(false);
      setswitch31(false);
      setswitch32(false);
      setswitch33(false);
      setswitch34(false);
      setswitch35(false);
      setswitch36(false);
      setOpenLoader(false);
      setSelectedUser({ label: 'Please Select User', value: 0 });
      // setTimeout(() => {
      //   history.push(`/CustomerUserReg`);
      // }, 3000);
      // } else {
      //   setusererr(true);
      //   setTimeout(() => {
      //     setusererr(false);
      //   }, 3000);

      //   setOpenLoader(false);
      // }
    } catch (error) {
      console.error('Error creating role:', error);
      setOpenLoader(false);
    }
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid={true}>
          <h6 className="titleuseraccess">Supplier Role Access</h6>
          <Card style={{ backgroundColor: 'white' }} boxs>
            <CardBody
              sx={{ boxShadow: 8 }}
              style={{
                color: '#1C6758',
              }}
            >
              <Stack my={1} mb={1}>
                <FormControl fullWidth size="small" style={{ color: 'black' }}>
                  <FormLabel style={{ fontWeight: 600, color: '#1C6758' }}>
                    Control User Access
                  </FormLabel>
                  <Select
                    placeholder="Please Select User "
                    name="Customer Help"
                    options={userhelps}
                    value={selectedUser}
                    onChange={e => {
                      Getuserrole(e);
                      console.log(e, 'selected user');
                    }}
                  />
                  {usererr ? (
                    <p className="error">Please Select User </p>
                  ) : null}
                </FormControl>
              </Stack>
              <Grid
                container
                spacing={1}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={3}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      Dashboard
                    </Typography>
                    <Switch
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch1(true);
                        } else {
                          setswitch1(false);
                        }
                      }}
                      checked={switch1}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  md={4}
                  xs={12}
                  lg={3}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      Customer Access Control
                    </Typography>
                    <Switch
                      className="mb-1"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch16(true);
                        } else {
                          setswitch16(false);
                        }
                      }}
                      checked={switch16}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={3}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      Ads Manner
                    </Typography>
                    <Switch
                      disabled={sessionStorage.getItem('enable_po') === 'N'}
                      // disabled={!BranchAccess}
                      className="mb-1"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch21(true);
                        } else {
                          setswitch21(false);
                        }
                      }}
                      checked={switch21}
                    />
                  </Stack>
                </Grid>
              </Grid>

              <Stack
                direction={{ sm: 'row', xs: 'column' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                p={2}
                borderRadius={8}
                m={2}
              >
                <Typography variant="subtitle2">Master</Typography>
                <Stack
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  borderRadius={8}
                >
                  <Typography variant="subtitle2" px={1}>
                    All Master
                  </Typography>
                  <Switch
                    className="mb-2"
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    onColor="#379237"
                    onHandleColor="#E5F9DB"
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={20}
                    width={48}
                    onChange={value => {
                      if (value) {
                        // if (sessionStorage.getItem('enable_inventory') === 'Y') {
                        setswitch11(true);
                        setswitch12(true);
                        setswitch15(true);
                        // }
                        setswitch9(true);
                        setswitch10(true);
                        setswitch13(true);
                        setswitch14(true);
                        setswitch18(true);
                        setswitch19(true);
                        setswitch20(true);
                        setswitch31(true);
                        setswitch32(true);
                        setswitch33(true);
                        setswitch34(true);
                        setswitch35(true);
                        setswitch36(true);
                      } else {
                        setswitch9(false);
                        setswitch10(false);
                        setswitch11(false);
                        setswitch12(false);
                        setswitch13(false);
                        setswitch14(false);
                        setswitch15(false);
                        setswitch18(false);
                        setswitch19(false);
                        setswitch20(false);
                        setswitch31(false);
                        setswitch32(false);
                        setswitch33(false);
                        setswitch34(false);
                        setswitch35(false);
                        setswitch36(false);
                      }
                    }}
                    checked={switch9}
                  />
                </Stack>
              </Stack>

              <Grid
                container
                spacing={1}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      Company
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch10(true);
                        } else {
                          setswitch10(false);
                        }
                      }}
                      checked={switch10}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      Customer
                    </Typography>
                    <Switch
                      //   disabled={
                      //     sessionStorage.getItem('enable_inventory') === 'N'
                      //   }
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch11(true);
                        } else {
                          setswitch11(false);
                        }
                      }}
                      checked={switch11}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      Customer Branch
                    </Typography>
                    <Switch
                      //   disabled={
                      //     sessionStorage.getItem('enable_inventory') === 'N'
                      //   }
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch12(true);
                        } else {
                          setswitch12(false);
                        }
                      }}
                      checked={switch12}
                    />
                  </Stack>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginRight: '26px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Product Category
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch13(true);
                        } else {
                          setswitch13(false);
                        }
                      }}
                      checked={switch13}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '40px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Tax
                    </Typography>
                    <Switch
                      //   disabled={
                      //     sessionStorage.getItem('enable_inventory') === 'N'
                      //   }
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch15(true);
                        } else {
                          setswitch15(false);
                        }
                      }}
                      checked={switch15}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '76px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      UOM
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch14(true);
                        } else {
                          setswitch14(false);
                        }
                      }}
                      checked={switch14}
                    />
                  </Stack>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '10px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Product
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch18(true);
                        } else {
                          setswitch18(false);
                        }
                      }}
                      checked={switch18}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '40px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Department
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch31(true);
                        } else {
                          setswitch31(false);
                        }
                      }}
                      checked={switch31}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '76px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Designation
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch32(true);
                        } else {
                          setswitch32(false);
                        }
                      }}
                      checked={switch32}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '76px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      User Register
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch33(true);
                        } else {
                          setswitch33(false);
                        }
                      }}
                      checked={switch33}
                    />
                  </Stack>
               
                 
                </Grid>

                   <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >             
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '76px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Company Log 
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch35(true);
                        } else {
                          setswitch35(false);
                        }
                      }}
                      checked={switch35}
                    />
                  </Stack>
               
                </Grid>

                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >             
                 <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '76px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Branch Log 
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch34(true);
                        } else {
                          setswitch34(false);
                        }
                      }}
                      checked={switch34}
                    />
                  </Stack>
               
                </Grid>

                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                    style={{ marginLeft: '76px' }}
                  >
                    <Typography variant="subtitle2" color="#">
                      Company Branch
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch36(true);
                        } else {
                          setswitch36(false);
                        }
                      }}
                      checked={switch36}
                    />
                  </Stack>
                 
                </Grid>
              </Grid>

              <Stack
                direction={{ sm: 'row', xs: 'column' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                p={2}
                borderRadius={8}
                m={2}
              >
                <Typography variant="subtitle2">Transaction</Typography>
                <Stack
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  borderRadius={8}
                >
                  <Typography variant="subtitle2" px={1}>
                    All Transaction
                  </Typography>
                  <Switch
                    className="mb-2"
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    onColor="#379237"
                    onHandleColor="#E5F9DB"
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={20}
                    width={48}
                    onChange={value => {
                      if (value) {
                        // if (sessionStorage.getItem('enable_inventory') === 'Y') {
                        setswitch22(true);
                        setswitch23(true);
                        setswitch24(true);
                        setswitch25(true);
                        // }
                      } else {
                        setswitch22(false);
                        setswitch23(false);
                        setswitch24(false);
                        setswitch25(false);
                      }
                    }}
                    checked={switch25}
                  />
                </Stack>
              </Stack>
              <Grid
                container
                spacing={1}
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      Quotation
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch22(true);
                        } else {
                          setswitch22(false);
                        }
                      }}
                      checked={switch22}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      PO Acceptance
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch23(true);
                        } else {
                          setswitch23(false);
                        }
                      }}
                      checked={switch23}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  sm={4}
                  xs={12}
                  md={4}
                  lg={4}
                  justifyContent={'center'}
                  alignItems={'center'}
                  spacing={1}
                >
                  <Stack
                    direction={'row'}
                    justifyContent={{ sm: 'space-evenly', xs: 'space-between' }}
                    alignItems={'center'}
                    p={2}
                    borderRadius={8}
                  >
                    <Typography variant="subtitle2" color="#">
                      SO Status Update
                    </Typography>
                    <Switch
                      className="mb-2"
                      uncheckedIcon={<Offsymbol />}
                      checkedIcon={<OnSymbol />}
                      onColor="#379237"
                      onHandleColor="#E5F9DB"
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      onChange={value => {
                        if (value) {
                          setswitch24(true);
                        } else {
                          setswitch24(false);
                        }
                      }}
                      checked={switch24}
                    />
                  </Stack>
                </Grid>
              </Grid>

              <Button
                fullWidth
                variant="outlined"
                color="success"
                onClick={() => {
                  createrole();
                }}
                sx={{ my: 2 }}
              >
                Save
              </Button>
            </CardBody>
          </Card>
        </Container>
      </div>

      {Userrolesuccess ? (
        <SweetAlert
          title="User Roles Added Successfully"
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setUserrolesuccess(false);
          }}
        ></SweetAlert>
      ) : null}

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress color="success" />
      </Dialog>
    </React.Fragment>
  );
}

export default Supplieraccess;
